<template>
  <section class="contact">
    <Grid class="contact-grid">
      <div class="grid-column x4">
        <div class="content txt">
          <img src="/static/img/avatar.png" class="avatar" />
          <p>
            Excellent results are a reflection of the people involved. Going through my stuff, you get to know me a little. If you think spending time on a venture together will create value
            for both of us, we should meet!
            <br />
            <br />
            <strong class="contacts">
              <a href="mailto:hello@humantechdesign.com">hello@humantechdesign.com</a>
            </strong>
            <br />
            <strong class="contacts">
              <a href="tel:+49 176 458 739 46">+49 176 458 739 46</a>
            </strong>
          </p>
        </div>
      </div>
    </Grid>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
export default {
  name: "Contact",
  components: {
    Grid
  }
};
</script>
<style scoped>
.contact {
  min-height: 50vh;
  padding-top: calc(var(--LINE-HEIGHT) * 3);
  padding-bottom: 0;
}

@media only screen and (max-width: 576px) {
  .contact {
    min-height: calc(50vh + var(--LINE-HEIGHT) * 5);
  }
}

.contact-grid {
  align-items: center;
  min-height: 50vh;
}
@media only screen and (max-width: 576px) {
  .contact-grid {
    min-height: 50vh;
  }
}

.avatar {
  border-radius: 100%;
  height: calc(var(--LINE-HEIGHT) * 5);
  margin-bottom: calc(var(--LINE-HEIGHT) * 1);
  background-color: lightcoral;
  vertical-align: bottom;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Contact.vue